import StorageService from './StorageService'
import * as firebase from 'firebase'
import 'firebase/firestore'
import Template from '@/models/Template'

export default class TemplateService extends StorageService {

  generateFullPath (item: Template) {
    return 'projects/' + item.projectId + '/templates/' + item.name + '.docx'
  }
  async fetchTemplates (projectId: string) {
    const arr: Array<Template> = []
    await this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_templates')
      .get()
      .then((snap: any) => {
        snap.forEach((doc: any) => {
          const item = doc.data() as Template
          item.id = doc.ref.id
          item.added = doc.data().added ? doc.data().added.toDate() : null
          item.updated = doc.data().updated ? doc.data().updated.toDate() : null
          arr.push(item)
        })
      })
      return arr
  }

  async createTemplate (item: Template) {
    item.fullPath = this.generateFullPath(item)
    return await this.uploadFile(item.fullPath, item.file)
      .then(async () => {
        item.added = new Date()
        item.updated = new Date()
        delete item.file
        return await this.$db
          .collection('projects')
          .doc(item.projectId)
          .collection('project_templates')
          .add(item)
          .then((result: any) => {
            return result
          })
          .catch((error: any) => {
              console.error('Error in createTemplate', error)
          })
      })
      .catch((error) => {
        console.error('Error in uploadFile', error)
      })
    
  }

  async editTemplate (item: Template) {
    item.added = new Date(item.added)
    item.updated = new Date()

    // delete old file
    await this.deleteFile(item.fullPath)
    // generate new file
    item.fullPath = this.generateFullPath(item)
    await this.uploadFile(item.fullPath, item.file)

    // store update in db
    delete item.file

    return await this.$db
      .collection('projects')
      .doc(item.projectId)
      .collection('project_templates')
      .doc(item.id)
      .update(item)
      .then((result: any) => {
        return result
      })
      .catch((error: any) => {
          console.error('Error in editTemplate', error)
      })
  }

  async deleteTemplate (item: Template) {
    return await this.deleteFile(item.fullPath)
      .then(async () => {
        return await this.$db
          .collection('projects')
          .doc(item.projectId)
          .collection('project_templates')
          .doc(item.id)
          .delete()
          .then(() => {
            return true
          })
          .catch((error: any) => {
            console.error('Error in deleteTemplate', error)
            return false
          })
        })
      .catch((error) => {
        console.error('Error in uploadFile', error)
      })
  }
}